let baseUrl
const repUrl = `${process.env.VUE_APP_REP_URL}`

if (process.env.VUE_APP_K8s) {
  let namespace = window.location.pathname
  namespace = namespace[namespace.length - 1] === '/' ? namespace.slice(0, namespace.length - 1) : namespace
  namespace = namespace.split('/new-front')[0] + '/back'
  baseUrl = `${window.location.origin}${namespace}`
} else {
  baseUrl = `${process.env.VUE_APP_API_URL}`
}

const config = {
  baseUrl,
  repUrl,
  //  iframeUrl: `${process.env.VUE_APP_IFRAME_URL}`,
  iframeUrl: window.location.origin.includes('localhost')
    ? 'http://localhost:8080'
    : window.location.origin + window.location.pathname + 'iframe/index.html',
  version: '5.0.0'
}

export default config
